import { TypeKeys, ActionTypes } from '../actions/index';

const getInitialState = (): DeployUpdateState => {
  return {
    deployProgress: 0,
    updateAvailable: false,
  };
};

const deployUpdate = (
  state = getInitialState(),
  action: ActionTypes
): DeployUpdateState => {
  switch (action.type) {
    case TypeKeys.SET_DEPLOY_STATUS: {
      const deployProgress =
        (action.downloadingProgress + action.extractingProgress) / 2;
      return {
        ...state,
        deployProgress,
      };
    }
    case TypeKeys.UPDATE_AVAILABLE: {
      const updateAvailable = action.updateAvailable;
      return {
        ...state,
        updateAvailable,
      };
    }
  }
  return state;
};

export default deployUpdate;
